import React from 'react'
import CompanyIntro from '../components/home/CompanyIntro'
import CoreServices from '../components/home/CoreServices'
import Advantages from '../components/home/Advantages'
import ContactSection from '../components/home/ContactSection'

const HomePage = () => {
  return (
    <div className="w-full">
      <div className="container mx-auto px-4 py-12">
        <CompanyIntro />
        <CoreServices />
        <Advantages />
        <ContactSection />
      </div>
    </div>
  )
}

export default HomePage